<template>
  <b-card bg-variant="light">
    <b-form-group
      label-cols-lg="3"
      :label="label"
      label-size="lg"
      label-class="font-weight-bold pt-0"
      class="mb-0"
    >
      <b-form-group label="Zipcode:" label-for="nested-postal">
        <b-form-input
          id="nested-postal"
          style="text-transform: capitalize"
          v-model="v[prefix + 'postalcode'].$model"
          @blur="$emit('postal-blur', v[prefix + 'postalcode'].$model)"
        ></b-form-input>
        <span
          v-if="
            !v[prefix + 'postalcode'].required &&
            v[prefix + 'postalcode'].$dirty
          "
          class="text-danger"
          >Zipcode is required!
        </span>
      </b-form-group>
      <b-form-row>
        <b-col cols="12" md="6">
          <b-form-group label="Street:" label-for="nested-street">
            <b-form-input
              id="nested-street"
              style="text-transform: capitalize"
              v-model="v[prefix + 'street'].$model"
            ></b-form-input>
            <span
              v-if="
                !v[prefix + 'street'].required && v[prefix + 'street'].$dirty
              "
              class="text-danger"
              >Street is required!
            </span>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group label="City:" label-for="nested-city">
            <b-form-input
              id="nested-city"
              style="text-transform: capitalize"
              v-model="v[prefix + 'city'].$model"
            ></b-form-input>
            <span
              v-if="!v[prefix + 'city'].required && v[prefix + 'city'].$dirty"
              class="text-danger"
              >City is required!
            </span>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="2">
          <b-form-group label="State:" label-for="nested-state">
            <b-form-select
              v-model="v[prefix + 'state'].$model"
              style="text-transform: capitalize"
              :options="stateOptions"
              class="mb-3"
            >
              <template v-slot:first>
                <b-form-select-option :value="null" disabled
                  >-- Please select an option --</b-form-select-option
                >
              </template>
            </b-form-select>
            <span
              v-if="!v[prefix + 'state'].required && v[prefix + 'state'].$dirty"
              class="text-danger"
              >State is required!
            </span>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-group label="Country:" label-for="nested-country">
        <!-- The placeholder is not decoration. A <select> whose bound value
             matches no option renders its first option instead, so without an
             empty first entry a null country displayed "United States" while
             the model stayed null - the box said one thing and "Country is
             required!" said another. Same treatment as the state select. -->
        <b-form-select
          v-model="v[prefix + 'country'].$model"
          :options="countryOptions"
          class="mb-3"
        >
          <template v-slot:first>
            <b-form-select-option :value="null" disabled
              >-- Please select an option --</b-form-select-option
            >
          </template>
        </b-form-select>
        <span
          v-if="!v[prefix + 'country'].required && v[prefix + 'country'].$dirty"
          class="text-danger"
          >Country is required!
        </span>
      </b-form-group>

      <slot name="actions" />
    </b-form-group>
  </b-card>
</template>

<script>
// Reusable address card used for both the billing and shipping addresses.
// `prefix` selects which account fields to bind ("billing" / "shipping");
// `v` is the parent's $v.account Vuelidate subtree, so $model setters write
// straight back to parent data. Divergent per-address controls (the
// same-as-billing checkbox, the renewal update buttons) are supplied by the
// parent through the `actions` slot. The zip @blur is emitted as `postal-blur`
// with the entered value so the parent can run its postal lookup.
import { stateOptions, countryOptions } from "./options";

export default {
  name: "AddressCard",
  props: {
    v: { type: Object, required: true },
    prefix: {
      type: String,
      required: true,
      validator: (p) => p === "billing" || p === "shipping",
    },
    label: { type: String, required: true },
  },
  data() {
    return { stateOptions, countryOptions };
  },
};
</script>
